import { render, staticRenderFns } from "./OopsDialog.vue?vue&type=template&id=5c6484fd&scoped=true"
import script from "./OopsDialog.vue?vue&type=script&lang=js"
export * from "./OopsDialog.vue?vue&type=script&lang=js"
import style0 from "./OopsDialog.vue?vue&type=style&index=0&id=5c6484fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6484fd",
  null
  
)

export default component.exports